module.exports = __webpack_public_path__ + "img/scotiabank.4d0ce4ae.svg";